import Typography from "@mui/material/Typography";
import MessageMarkdownContent from "_shared/_views/markdown/message-markdown-content";
import type { NotificationType } from "notifications/notification-type";

export default function NotificationContent({ notification }: Readonly<{ notification: NotificationType }>) {
  const hasStructuredContent = Boolean(notification.subheader || notification.body || notification.finePrint);
  if (!hasStructuredContent) {
    return notification.message?.value ? (
      <MessageMarkdownContent compact content={notification.message.value} />
    ) : null;
  }

  return (
    <>
      {notification.subheader && <Typography variant="body2">{notification.subheader}</Typography>}
      {notification.body && <MessageMarkdownContent compact content={notification.body} />}
      {notification.finePrint && (
        <Typography component="div" variant="caption" color="text.disabled">
          {notification.finePrint}
        </Typography>
      )}
    </>
  );
}
